import React from 'react'
import { Container } from '@mui/material'
import { mainDiv } from './styles'

export default function Page ({ children }) {
  return <Container sx={mainDiv}>{children}</Container>
}
